import {
	GetCarUseResultQuery,
	GetCurrentCarPlaceQuery,
	GetEventVideoQuery,
	GetG500LiteMasterInfoWithOrganizationIdQuery,
	GetMasterInfoQuery,
	GetOffsegMasterInfoWithOrganizationIdQuery,
	RegisterAccountQuery,
} from '../type/QueryType';
import { responseType } from '../type/ResponseType';
import * as apiType from '../../API';

type QueryResponse =
	| GetMasterInfoQuery
	| GetOffsegMasterInfoWithOrganizationIdQuery
	| GetG500LiteMasterInfoWithOrganizationIdQuery
	| GetCurrentCarPlaceQuery
	| GetCarUseResultQuery
	| GetEventVideoQuery
	| RegisterAccountQuery;

type OffsegResponse = apiType.GetCarUseResultResponse;

// responseTypeのエラー判定の基準値、基準値以上の場合エラーとする
export const errorResponseTypeStandard = 90 as const;

/**
 * APIのレスポンスがエラーかどうかを判定する
 */
export const isResponseTypeError = (queryResponse: QueryResponse) => {
	let isResponseTypeError = false;
	Object.values(queryResponse).forEach((result) => {
		// 存在しない場合はresponseTypeを確認できないため、スキップ
		if (!result) {
			return;
		}

		// 1件でもエラー対象が存在すればエラー判定する
		if (result.responseType >= errorResponseTypeStandard) {
			isResponseTypeError = true;
		}
	});

	return isResponseTypeError;
};

/**
 * APIのレスポンスがセッション非存在エラーかどうか判定する
 */
export const isResponseTypeSessionNotExist = (queryResponse: QueryResponse) => {
	const isResponseTypeSessionNotExist = Object.values(queryResponse).some(
		(result) => result && result.responseType === responseType.notExistSessionInfo,
	);
	return isResponseTypeSessionNotExist;
};

/**
 * Offseg APIのレスポンスが上限超過エラーかどうか判定する
 */
export const isOffsegResponseTypeLimitOverError = (offsegResponse: OffsegResponse) => {
	return offsegResponse.responseType === responseType.limitOverError;
}
